<template>
  <div class="home">
    <h1>Master Price List</h1>

    <b-row>
      <b-col cols="6">
        <router-link to="product/search">
          <icon name="search" scale="3"></icon>
          Search
        </router-link>
      </b-col>

      <b-col cols="6">
        <router-link to="product/create">
          <icon name="plus" scale="3"></icon>
          Add
        </router-link>
      </b-col>

    </b-row>

    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="2">
        <router-link to="family/all">
          <icon name="photo" scale="3"></icon>
          Families / Discounts
        </router-link>
      </b-col>

      <b-col cols="2">
        <router-link to="roof/all">
          <icon name="home" scale="3"></icon>
          Roofs
        </router-link>
      </b-col>

      <b-col cols="2">
        <router-link to="colour/all">
          <icon name="window-restore" scale="3"></icon>
          Colours
        </router-link>
      </b-col>

      <b-col cols="2">
        <router-link to="user/all">
          <icon name="user" scale="3"></icon>
          Users
        </router-link>
      </b-col>

      <b-col cols="2">
        <router-link to="extra/all">
          <icon name="plus" scale="3"></icon>
          Extras
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hello.vue